<dx-toolbar [items]="toolbarItems"></dx-toolbar>
<div class="grid-container">
  <dx-data-grid
    #useCaseGrid
    [dataSource]="useCases$ | async"
    [columns]="columnsUseCases"
    keyExpr="id"
    [(selectedRowKeys)]="selectedRowKey"
    (onSelectionChanged)="onSelectionChanged($event)"
    [showBorders]="true"
    [filterRow]="{
      visible: true
    }"
  >
    <dxo-editing [allowUpdating]="true" [useIcons]="true" mode="popup" newRowPosition="last"> </dxo-editing>
    <dxo-selection [allowSelectAll]="true" mode="multiple"></dxo-selection>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>

<dx-popup
  *ngIf="visible"
  title="Use case"
  [hideOnOutsideClick]="true"
  [height]="400"
  [visible]="true"
  [width]="600"
  (onHiding)="hidePopup()"
>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="saveBtnOptions"> </dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="cancelBtnOptions"> </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="useCaseFormGroup">
      <dx-text-box
        formControlName="name"
        label="Name"
        labelMode="floating"
        stylingMode="outlined"
        [validationStatus]="useCaseFormGroup.controls.name.errors && useCaseFormGroup.controls.name.touched ? 'invalid' : 'valid'"
        [validationErrors]="[{ type: 'required', message: 'Name is mandatory!' }]"
      ></dx-text-box>
      <dx-select-box
        formControlName="process"
        label="Process"
        labelMode="floating"
        [dataSource]="filteredProcesses"
        displayExpr="name"
        [showClearButton]="true"
        [acceptCustomValue]="true"
        customItemCreateEvent="focusout"
        (onCustomItemCreating)="onCustomItemCreating($event, 'process')"
        (onSelectionChanged)="onProcessChanged($event)"
        [searchEnabled]="true"
        searchExpr="name"
        stylingMode="outlined"
        [validationStatus]="useCaseFormGroup.controls.process.errors && useCaseFormGroup.controls.process.touched ? 'invalid' : 'valid'"
        [validationErrors]="[{ type: 'required', message: 'Process is mandatory!' }]"
      ></dx-select-box>
      <dx-select-box
        formControlName="domain"
        label="Domain"
        labelMode="floating"
        [dataSource]="domains"
        displayExpr="name"
        (onSelectionChanged)="onDomainChanged($event)"
        [showClearButton]="true"
        [acceptCustomValue]="true"
        customItemCreateEvent="focusout"
        (onCustomItemCreating)="onCustomItemCreating($event, 'domain')"
        [searchEnabled]="true"
        searchExpr="name"
        stylingMode="outlined"
        [validationStatus]="useCaseFormGroup.controls.domain.errors && useCaseFormGroup.controls.domain.touched ? 'invalid' : 'valid'"
        [validationErrors]="[{ type: 'required', message: 'Domain is mandatory!' }]"
      ></dx-select-box>
    </form>
  </div>
</dx-popup>

<dx-popup
  *ngIf="visibleDelete"
  title="Deletion"
  [hideOnOutsideClick]="true"
  [height]="250"
  [visible]="true"
  [width]="300"
  (onHiding)="hideDeletePopup()"
>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="deleteBtnOptions"> </dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="cancelDeleteBtnOptions"> </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    Are you sure to delete <strong>{{ selectedUseCases.join(", ") }}</strong>
    ?
  </div>
</dx-popup>
